import { useNavigate } from 'react-router-dom'

import { Header } from '@paysense-india-services/elevate-web'

import { ROUTES } from '@/constants/routes'

import LoanDocumentsPanel from '@/components/LoanDocumentsPanel'
import PageContainer from '@/components/PageContainer'

const DocumentsPage = () => {
  const navigate = useNavigate()

  return (
    <>
      <Header
        className='ew-typography-normal'
        isBackButton={true}
        isPageTitle={true}
        onBack={() => navigate(ROUTES.DASHBOARD)}
        title='Loan Documents'
      />
      <div style={{ marginTop: '56px' }} />
      <div className='appLayout'>
        <PageContainer className='ew-d-flex ew-flex-column'>
          <LoanDocumentsPanel showGreeting />
        </PageContainer>
      </div>
    </>
  )
}

export default DocumentsPage
